import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  setValue(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  getValue(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  setJson<T>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getJson<T>(key: string, fallback: T): T {
    const stored = sessionStorage.getItem(key);
    if (!stored) return fallback;
    try {
      return JSON.parse(stored) as T;
    } catch {
      return fallback;
    }
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }
}
